/* If this context will be provided than this function will return the body of that specific context */
const getBody = function (context) {
    return context
        ? context.getElementsByTagName('body')[0]
        : document.getElementsByTagName('body')[0];
};
export default getBody;
